import axios from "axios";
import { WEB_SERVER_ADDR } from "../../constValues";
import Auth from "../../Auth/Auth";

const API = () => {
  const client = axios.create({
    baseURL: `${WEB_SERVER_ADDR}`,
    headers: {
      Pragma: "no-cache"
    }
  });

  client.interceptors.request.use(config => {
    const token = Auth.getUserToken();
    if (token) {
      config.headers = { ...config.headers, token };
    } else if (config.headers) {
      delete config.headers.token;
    }
    return config;
  });

  return client;
};

export default API;
